import { create } from 'zustand';

export type ToastSeverity = 'success' | 'error' | 'info' | 'warning';

export interface ToastItem {
  id: number;
  message: string;
  severity: ToastSeverity;
}

interface ToastState {
  items: ToastItem[];
  push: (message: string, severity?: ToastSeverity) => void;
  remove: (id: number) => void;
}

export const useToast = create<ToastState>((set) => ({
  items: [],
  push: (message, severity = 'info') => {
    const id = Date.now() + Math.random();
    set((s) => ({ items: [...s.items, { id, message, severity }] }));
    setTimeout(() => {
      set((s) => ({ items: s.items.filter((t) => t.id !== id) }));
    }, 3600);
  },
  remove: (id) => set((s) => ({ items: s.items.filter((t) => t.id !== id) })),
}));

export const toast = {
  success: (m: string) => useToast.getState().push(m, 'success'),
  error: (m: string) => useToast.getState().push(m, 'error'),
  info: (m: string) => useToast.getState().push(m, 'info'),
  warning: (m: string) => useToast.getState().push(m, 'warning'),
};
